import styles from './list.module.scss';
import React from 'react';
import {classNames} from '../../support/classnames.ts';

interface OwnProps {
    onClick?: () => void;
    children: React.ReactNode;
}

export function ListItem({children, onClick}: OwnProps) {
    return (
        <li
            className={classNames(styles.list__item, {
                [styles.interactive]: onClick !== undefined,
            })}
            onClick={onClick}
        >
            {children}
        </li>
    );
}
